export { default } from './components/FeedPost'
